export const CONFIG = {
  IS_TEST_WAITING_TICKET:
    process.env.REACT_APP_IS_TEST_WAITING_TICKET === "true" ? true : false,
  ENV: process.env.REACT_APP_ENV || "develop",
  API_URL:
    process.env.REACT_APP_API_URL ||
    "https://artemis-agent-api.secure-restapi.com",
  IS_DISABLED_SPECIAL: process.env.REACT_APP_IS_DISABLED_SPECIAL || false,
  BASE_URL: process.env.REACT_APP_BASE_URL || "newiframe.imebot.com",
};
